module.exports = __webpack_public_path__ + "images/automations-icon.png";